import httpClient, { paramsToString } from '@/services/http/httpClient'
import serializeObject from '@/utils/serializeObject'
import { blobToFile } from '@/infra/blobs'

export const apiGetPostalChartsData = (searchParams) => {
  let params
  if (searchParams) {
    const parsedParams = (Object.keys(searchParams).length > 0 ? '?' : '') + serializeObject(searchParams)
    params = parsedParams
  } else {
    params = ''
  }
  return httpClient.get(`charts/graphics${params}`)
    .then(data => data)
}

export const apiGetPostalTableData = (searchParams) => {
  let params
  if (searchParams) {
    const parsedParams = (Object.keys(searchParams).length > 0 ? '?' : '') + serializeObject(searchParams)
    params = parsedParams
  } else {
    params = ''
  }
  return httpClient.get(`charts/table${params}`)
    .then(data => data)
}

export const apiGetPostCodes = (searchParams) => {
  let params
  if (searchParams) {
    const parsedParams = (Object.keys(searchParams).length > 0 ? '?' : '') + serializeObject(searchParams)
    params = parsedParams
  } else {
    params = ''
  }
  return httpClient.get(`charts/postalCodes/${params}`)
    .then(data => data)
}

export const apiGetReportBlob = (fileName, filtersObj, mimeType) => {
  const params = new URLSearchParams()
  if (filtersObj) {
    Object.keys(filtersObj).forEach(key => {
      const parsedKey = encodeURIComponent(key)
      const parsedValue = encodeURIComponent(filtersObj[key])
      params.append(parsedKey, parsedValue)
    })
  }

  return httpClient.get(`/charts/export${paramsToString(params)}`, {
    responseType: 'blob'
  })
    .then(response => {
      blobToFile(fileName, response, mimeType)
    })
}

export const apiGetChartWarrantyTypes = () => {
  return httpClient.get('charts/warranties/')
    .then(data => data)
}

export const apiGetChartWarrantySubtypes = warrantyId => {
  const params = new URLSearchParams()
  if (warrantyId) {
    params.set('warranty_id', warrantyId)
  }

  return httpClient.get(`charts/warrantiesSubtypes/${paramsToString(params)}`)
    .then(data => data)
}
